import { __assign, __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { border, color } from '@metro-ui/tokens';
import { PanelFooter, WrappedPanelComponent, } from '../../Panel';
export var ModalFooter = styled(WrappedPanelComponent)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top: ", " solid ", ";\n"], ["\n  border-top: ", " solid ", ";\n"])), border.width.thin, color.palette.grey.tint[90]);
ModalFooter.propTypes = __assign({}, PanelFooter.propTypes);
var templateObject_1;
//# sourceMappingURL=ModalFooter.js.map